import { observer } from 'mobx-react-lite'
import React from 'react'
import { Button, EmptyState, SpinnerLoader, Typography } from 'shared/ui'
import { makeTextFieldClear, makeTextFieldIcon, TextField } from 'shared/ui/TextField'
import { LINK_FEATURE_REQUESTS } from 'shared/constants/links'
import { IntegrationListCard } from 'pages/settings/pages/integrations/pages/integrationList/ui/IntegrationListCard/IntegrationListCard'
import { useIntegrationListContext } from 'pages/settings/pages/integrations/context/integrationListContext'
import { IntegrationCategory } from 'pages/settings/pages/integrations/pages/integrationList/ui/IntegrationCategory'
import styles from './styles.module.scss'

export const IntegrationListContent = observer(() => {
  const {
    integrationList,
    isIntegrationListLoading,
    search,
    setSearch,
    isCategoriesLoading,
    currentListTitle,
    isEmptyList,
  } = useIntegrationListContext()

  const handleFeatureRequestClick = (e: React.MouseEvent) => {
    // https://salesmsg.atlassian.net/browse/SWC-10468
    e.stopPropagation()
    e.preventDefault()
    window.open(LINK_FEATURE_REQUESTS, '_blank', 'noopener,noreferrer')
  }

  if (isCategoriesLoading) {
    return <SpinnerLoader ariaLabel={'IntegrationListContent'} />
  }

  return (
    <div className={styles.container}>
      <div className={styles.sidebar}>
        <IntegrationCategory />
        <a
          href={LINK_FEATURE_REQUESTS}
          target='_blank'
          rel='noreferrer'
          onClick={handleFeatureRequestClick}
        >
          <Button
            typeBtn={'stroke'}
            icon='add'
            iconClassName={styles.requestIntegrationIconContainer}
            iconProps={{
              padding: '4px',
              insideBox: true,
              className: styles.requestIntegrationIcon,
            }}
            className={styles.requestIntegrationButton}
            text={'Request an integration'}
            fullWidth
          />
        </a>
      </div>
      <div className={styles.content}>
        <TextField
          size={'small'}
          onChange={setSearch}
          variant={'stroke'}
          value={search}
          InputProps={{
            placeholder: 'Search',
          }}
          leftActions={[
            makeTextFieldIcon({
              icon: 'search',
              fontSize: 16,
              color: 'var(--content-primary-tertiary)',
              margin: 0,
            }),
          ]}
          rightActions={[makeTextFieldClear()]}
        />
        <Typography variant='body-lg-medium' ariaLabel='IntegrationList_title' marginBottom={4}>
          {currentListTitle}
        </Typography>
        {isIntegrationListLoading && <SpinnerLoader ariaLabel={'IntegrationListContent'} />}
        {isEmptyList && (
          <EmptyState
            title={"Can't find what you need?"}
            text={'Request an integration'}
            actions={
              <a
                href={LINK_FEATURE_REQUESTS}
                target='_blank'
                rel='noreferrer'
                onClick={handleFeatureRequestClick}
              >
                <Button
                  contained={'secondary'}
                  text={'Request'}
                  iconProps={{ icon: 'add' }}
                  size={'medium'}
                />
              </a>
            }
            noIcon
          />
        )}
        <div className={styles.list}>
          {!isIntegrationListLoading &&
            integrationList.map((integration) => (
              <IntegrationListCard key={integration.id} integration={integration} />
            ))}
        </div>
      </div>
    </div>
  )
})
